import { kttuTours } from '../app/components/destinationCatalog';
import { courseAudienceLabels, courseAudienceValues, coursesFor } from './courses';
import type { Offer } from './schemas';

export type OfferCategory = 'excursion' | 'masterclass' | 'course';
export type OfferGroup = { label: string; offers: readonly Offer[] };

/**
 * What the booking form offers, by category and group (the `<select>` optgroups). A category without
 * offers (master classes for now) is not shown; adding offers to it makes it appear in the form.
 */
export const offerCategories: ReadonlyArray<{ id: OfferCategory; label: string; groups: readonly OfferGroup[] }> = [
  { id: 'excursion', label: 'Экскурсия', groups: [{ label: 'МУП «КТТУ»', offers: kttuTours.map((tour) => tour.id) }, { label: 'На свежем воздухе', offers: ['botanical_walk'] }] },
  { id: 'masterclass', label: 'Мастер-класс', groups: [] },
  { id: 'course', label: 'Курс или лекция', groups: courseAudienceValues.map((audience) => ({ label: courseAudienceLabels[audience], offers: coursesFor(audience) })) },
];

export function offerCategory(offer: Offer): OfferCategory {
  const category = offerCategories.find(({ groups }) => groups.some((group) => group.offers.includes(offer)));
  if (!category) throw new Error(`Offer ${offer} is missing from offerCategories`);
  return category.id;
}
